import { type Html, html, View } from 'rune-ts';
import klass from './MainSection.module.scss';
import { getResizedUrl } from '@services/MarppleShop/shared/util/image.ts';
import { font } from '@services/MarppleShop/shared/typography';

export class MainSection extends View<{ is_mobile: boolean }> {
  override template(): Html {
    const { is_mobile } = this.data;
    const banner_url = is_mobile
      ? '//s3.marpple.co/files/u_29089/2025/11/original/aad68837f3f10aabdfba0dc3a9e7fbf26cdfb1751.webp'
      : '//s3.marpple.co/files/u_29089/2025/11/original/e083b3f329bd251203ccfb84f1639b6fa263bd4c1.png';
    const banner_title_url = is_mobile
      ? '//s3.marpple.co/files/u_29089/2025/11/original/4e113610fa2442dd8cba30ff970fe57bcc856e3c1.png'
      : '//s3.marpple.co/files/u_29089/2025/11/original/4e113610fa2442dd8cba30ff970fe57bcc856e3c1.png';
    return html`
      <section class="${klass.container}">
        <img
          src="${getResizedUrl({
            url: banner_url,
            quality: 85,
            format: 'webp',
            width: 1920 * 2,
          })}"
          class="${klass.banner_img}"
          alt=""
        />
        <div class="${klass.content}">
          <div class="${klass.title_wrapper}">
            <img
              src="${getResizedUrl({
                url: banner_title_url,
                width: 400 * 2,
                quality: 85,
                format: 'webp',
              })}"
              class="${klass.title}"
              alt="메인 타이틀"
            />
          </div>
          <div class="${klass.title_wrapper}">
            <div class="${klass.title} ${font('48_bold', '20_bold')}">
              굿즈 제작과 판매가 막막했다면<br />마플샵 굿즈 파트너스가 되어보세요!
            </div>
            <div class="${klass.sub_title} ${font('20_medium', '14_medium')}">
              굿즈 기획부터 정산까지 모든 과정을
              <span class="${klass.mo_br}">전담 매니저가 함께 해드립니다.</span>
            </div>
          </div>
          <div class="${klass.button_wrapper}">
            <a
              href="https://tally.so/r/3xBxgy"
              target="_blank"
              class="${klass.apply_button} goods_partners__apply_button_top"
            >
              <div class="${font('28_bold', '16_bold')}">지금 바로 지원하기</div>
            </a>
          </div>
        </div>
      </section>
    `;
  }

  override onRender() {
    this.delegate('click', '.goods_partners__apply_button_top', () => {
      if (typeof window.gtag == 'function' && G.collabo_type == 'creator') {
        window.gtag('event', '상단버튼클릭_버튜버', { event_category: '상단버튼클릭_버튜버' });
      }
    });

    this.delegate('click', '.goods_partners__apply_button_top', () => {
      if (typeof window.gtag == 'function' && G.collabo_type == 'creator') {
        window.gtag('event', '상단버튼클릭_팬', { event_category: '상단버튼클릭_팬' });
      }
    });
  }
}
